import { LocationSystemIcon, CommentSystemIcon } from '@nib/icons';
import socialMedia from './_socialMedia';
import { getBaseUrl } from './utils';
const PHONE_NUMBER = '13 16 42';
const CORPORATE_PHONE_NUMBER = '1800 13 14 63';
const ABSOLUTE_BASEURL = 'https://www.nib.com.au';
const getArhiConfig = config => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  return {
    id: 'footer-arhi',
    columns: [{
      id: 'ga-footer-about-nib',
      title: 'About nib',
      children: [{
        id: 'ga-footer-our-company',
        title: 'Our company',
        url: `${baseUrl}/about-us`
      }, {
        id: 'ga-footer-nib-thrive',
        title: 'nib Thrive (NDIS)',
        url: `${baseUrl}/thrive`
      }, {
        id: 'ga-footer-nib-foundation',
        title: 'nib foundation',
        url: `${baseUrl}/foundation`
      }, {
        id: 'ga-footer-shareholders',
        title: 'Shareholders',
        url: `${baseUrl}/shareholders/home`
      }, {
        id: 'ga-footer-corporate-plans',
        title: 'Corporate plans',
        url: `${baseUrl}/corporate-plans`
      }, {
        id: 'ga-footer-for-providers',
        title: 'For providers',
        url: `${baseUrl}/providers`
      }, {
        id: 'ga-footer-careers',
        title: 'Careers',
        url: `${baseUrl}/careers`
      }]
    }, {
      id: 'ga-footer-helpful-links',
      title: 'Helpful links',
      children: [{
        id: 'ga-footer-forms-brochures',
        title: 'Forms & brochures',
        url: `${baseUrl}/health-information/member-services/forms-and-brochures`
      }, {
        id: 'ga-footer-going-to-hospital',
        title: 'Going to hospital',
        url: `${baseUrl}/health-information/going-to-hospital`
      }, {
        id: 'ga-footer-policy-booklet',
        title: 'Policy booklet',
        url: `${baseUrl}/docs/policy-booklet`,
        targetBlank: true
      }, {
        id: 'ga-footer-lifetime-health-cover',
        title: 'Lifetime Health Cover (LHC)',
        url: `${baseUrl}/health-information/healthcare-in-australia/lifetime-health-cover`
      }, {
        id: 'ga-footer-media-centre',
        title: 'Media centre',
        url: `${baseUrl}/media`
      }, {
        id: 'ga-footer-mobile-app',
        title: 'Download the nib App',
        url: `${baseUrl}/mobile-apps`
      }, {
        id: 'ga-footer-life-insurance-and-income-protection',
        title: 'Life Insurance & Income Protection',
        url: `${baseUrl}/life-insurance`
      }, {
        id: 'ga-footer-changes-that-may-impact-you',
        title: 'Changes that may impact you',
        url: `${baseUrl}/legal/changes-that-may-impact-you`
      }]
    }],
    contact: {
      heading: 'Get in touch',
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      contactLinks: [{
        id: 'ga-footer-find-provider',
        title: 'Find a Provider',
        url: `${baseUrl}/find-a-provider`,
        icon: LocationSystemIcon
      }, {
        id: 'ga-footer-dental-care',
        title: 'Find an nib Dental Care Centre',
        url: `${baseUrl}/health-information/first-choice-dental`,
        icon: LocationSystemIcon
      }, {
        id: 'ga-footer-eye-care',
        title: 'Find an nib First Choice Optical provider',
        url: `${baseUrl}/health-information/first-choice-optical`,
        icon: LocationSystemIcon
      }, {
        id: 'ga-footer-feedback-and-complaints',
        title: 'Feedback & complaints',
        url: `${baseUrl}/health-information/member-services/feedback-and-complaints`,
        icon: CommentSystemIcon
      }],
      socialLinks: socialMedia
    },
    smallFooterConfig: {
      id: 'small-footer-arhi',
      copyrightText: `Copyright © ${new Date().getFullYear()} nib health funds limited ABN 83 000 124 381`,
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      links: [{
        id: 'ga-footer-fund-rules',
        title: 'Fund Rules',
        url: `${baseUrl}/docs/fund-rules`
      }, {
        id: 'ga-footer-terms',
        title: 'Terms & Conditions',
        url: `${baseUrl}/docs/online-terms`,
        targetBlank: true
      }, {
        id: 'ga-footer-privacy',
        title: 'Privacy Policy',
        url: `${baseUrl}/legal/privacy-policy`
      }, {
        id: 'ga-footer-code-conduct',
        title: 'Code of Conduct',
        url: `${baseUrl}/legal#codeofconduct`
      }]
    }
  };
};
export default getArhiConfig;